// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import {
  LOADING_HIDE,
  LOADING_SHOW,
} from './types'

const initialState = 0

const loading = (state = initialState, action) => {
  switch (action.type) {
    case LOADING_HIDE :
      // conditional shouldn't ever be true but just in case
      // this gaurantees that this action type will never display
      // the loading icon, only reduce the number of async loading operations
      // or simply be passed through
      return !state ? state : state - 1

    case LOADING_SHOW :
      return state + 1

    default :
      return state
  }
}

export default loading
